import {
  faEnvelope,
  faGear,
  faHomeHeart,
} from "@fortawesome/duotone-light-svg-icons"
import { useTranslation } from "react-i18next"

import TabNavItem from "../../../components/tabNav/TabNavItem"
import useMobile from "../../../hooks/useMobile"
import { usePageWrapperScroll } from "../../../hooks/usePageWrapperScroll"
import { useFamilyMailQuery } from "../../../networking/queries"
import { ParentTabNavOption } from "../../../types"
import useParentTabNavStore from "../hooks/useParentTabNavStore"

const ParentTabNav = () => {
  const { selectedTab, setSelectedTab } = useParentTabNavStore()
  const { t } = useTranslation()
  const isMobile = useMobile()
  const { isScrolled } = usePageWrapperScroll()

  const { data: unreadMail } = useFamilyMailQuery({
    isUnread: true,
  })

  const hasUnreadMail = unreadMail && unreadMail.length > 0

  return (
    <div
      className={`flex flex-row sticky top-[80px] z-20 ${isMobile ? "justify-evenly border-b border-borderPrimary  bg-white " : "justify-start bg-bgXLightGray"} ${isScrolled ? "shadow-low-bottom" : ""}`}
    >
      <TabNavItem
        label={t("FT_TAB_GENERAL")}
        onClick={() => setSelectedTab(ParentTabNavOption.HOME)}
        icon={faHomeHeart}
        isSelected={selectedTab === ParentTabNavOption.HOME}
      />
      <TabNavItem
        label={t("FT_TAB_MAILBOX")}
        onClick={() => setSelectedTab(ParentTabNavOption.MAILBOX)}
        icon={faEnvelope}
        isSelected={selectedTab === ParentTabNavOption.MAILBOX}
        showNotificationDot={hasUnreadMail}
      />
      <TabNavItem
        label={t("FT_TAB_ACCOUNT")}
        onClick={() => setSelectedTab(ParentTabNavOption.ACCOUNT)}
        icon={faGear}
        isSelected={selectedTab === ParentTabNavOption.ACCOUNT}
      />
    </div>
  )
}

export default ParentTabNav
